export const getIsGitVcsRoot = (vcsName?: string | null) =>
  vcsName === 'jetbrains.git' || vcsName === 'git'
